import React from 'react';

export const RepoIcon: React.FC<{ color?: string }> = ({
  color = '#C4964D'
}) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1672_98262)">
        <path
          d="M14 0H5.18253L0 5.17975V14H5.90315V5.89999H14V0Z"
          fill={color}
        />
        <path
          d="M10.698 14.0001C12.5217 14.0001 14.0002 12.5224 14.0002 10.6996C14.0002 8.87683 12.5217 7.39917 10.698 7.39917C8.8742 7.39917 7.39575 8.87683 7.39575 10.6996C7.39575 12.5224 8.8742 14.0001 10.698 14.0001Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1672_98262">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
